// material ui
import { Theme } from '@mui/material';

export const cardCustomization = {
  MuiCard: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => {
        const isDark = theme.palette.mode === 'dark';
        const cardBoxShadow = isDark
          ? '0px 8px 24px rgba(0, 0, 0, 0.28)'
          : '0px 5px 14px rgba(33, 38, 45, 0.08)';

        return {
          backgroundColor: isDark
            ? theme.palette.grey[1000]
            : theme.palette.grey[0],
          borderRadius: '6px',
          backgroundImage: 'none',
          boxShadow: cardBoxShadow,

          '&.MuiPaper-elevation': {
            backgroundColor: isDark
              ? theme.palette.grey[1000]
              : theme.palette.grey[0],
          },

          '&.MuiCard-outlined': {
            borderWidth: '1px',
            borderColor: theme.palette.divider,
          },
        };
      },
    },
  },
};
